import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import {
  NgbDatepickerModule,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap'
import {
  setDate,
  setMonth,
  setYear,
  startOfDay,
} from 'date-fns'
import { DateStructPipe } from 'src/app/shared/pipes/dateStruct.pipe'
import { est, flipDateFn } from 'src/app/shared/utilities/date'
import { pipe } from 'lodash/fp'

@Component({
  imports: [NgbDatepickerModule, FormsModule, DateStructPipe],
  selector: 'app-date-picker',
  styles: `
    :host {
      display: flex;
      justify-content: center;
    }

    ngb-datepicker.app-datepicker::ng-deep {
      border: none;
      border-radius: 0;
      padding: 0;
      font-size: 0.9rem;
      line-height: 1.25rem;

      .bg-primary {
        background-color: var(--active-blue) !important;
      }

      .ngb-dp-header {
        background-color: transparent;

        .ngb-dp-arrow{
          display: none;
        }
      }

      .ngb-dp-months {
        display: block;
        width: 100%;

        .ngb-dp-week {
          justify-content: space-between;
          display: none;

          &:has(.ngb-dp-day:not(.hidden)) {
            display: flex;
          }
        }
      }

      .ngb-dp-weekdays {
        display: flex !important; 
        background-color: transparent;
        border: none;

        .ngb-dp-weekday {
          color: black;
          font-weight: 700;
        }
      }

      .ngb-dp-month:first-child .ngb-dp-week {
        padding-left: 0; 
      }

      .ngb-dp-month:last-child .ngb-dp-week {
        padding-right:0; 
      }

      .ngb-dp-navigation-select {
        justify-content: space-between;
        gap: 1rem;
        width: 100%;

        select {
          width: 100%;
          padding: 0.5rem 1rem 0.25rem 1rem;
          position: relative;
          border: none;
          background: white;
          text-align: center;
          border-bottom: 1px solid black;
          border-radius: 0;
          -moz-appearance: none; /* Firefox */
          -webkit-appearance: none; /* Safari and Chrome */
          appearance: none;

          &:focus {
            outline: none;
            box-shadow: none;
          }

          
        }
      }

      [ngbDatepickerDayView] {
        border-radius: 50%;
      }
      
      ngb-datepicker-month {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        margin-top: 0.75rem;
      }
    }
    `,
  template: ` <ngb-datepicker
    class="app-datepicker"
    [minDate]="minDate!"
    [startDate]="(value | dateStruct: true)!"
    [ngModel]="value | dateStruct"
    (ngModelChange)="onValueChange($event)"
    outsideDays="hidden"
  />`,
})
export class DatePickerComponent {
  minDate: NgbDateStruct = {
    year: 2007,
    month: 1,
    day: 1,
  }

  @Input()
  public value?: Date | string | null

  @Output()
  valueChange = new EventEmitter<Date>()

  onValueChange(struct: NgbDateStruct){
    const date = this.toModel(struct)
    if(date) {
      this.valueChange.emit(date)
    }
  }

  toModel(date: NgbDateStruct | null): Date | null {
    if (!date) {
      return null
    }
    return pipe(
      startOfDay,
      flipDateFn(setYear, date.year),
      flipDateFn(setMonth, date.month - 1),
      flipDateFn(setDate, date.day),
    )(est())
  }
}
